/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryOutByOrderIdQuery } from '../../models/get-inventory-out-by-order-id-query';
import { GetInventoryOutByOrderIdQueryResult } from '../../models/get-inventory-out-by-order-id-query-result';

export interface ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Params {
      body?: GetInventoryOutByOrderIdQuery
}

export function apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>;
    })
  );
}

apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain.PATH = '/api/NurseryManager/InventoryOut/GetInventoriesOutByOrderDetailsId';
